import { connect } from 'react-redux';
import { getFormValues, reset, isDirty, destroy } from 'redux-form';
import { Dispatch, bindActionCreators } from 'redux';
import { actions as uiActions } from 'ducks/ui';
import { IApplicationState } from 'ducks/reducers';
import MovementDetails from './MovementDetails';

const FORM_NAME = 'MovementDetails';
const params = new URLSearchParams(location.search);

const mapStateToProps = (state: IApplicationState) => {
    return {
        selectedMovementEnquiryId: params.get('MovementId') || 0,
        dirty: isDirty(FORM_NAME)(state),
        formValues: getFormValues(FORM_NAME)(state),
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeConfirmationDialog: uiActions.changeConfirmationDialog,
        resetForm: () => reset(FORM_NAME),
        destroyForm: () => destroy(FORM_NAME),
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MovementDetails);
